import { Typography } from "@mui/material";
import React from "react";
import ContentSection from "./ContentSection";
import { useTranslation } from "react-i18next";

interface Props {

}

const NotFound : React.FC<Props> = () => {
    const {t} = useTranslation("common");
    return <>
    <ContentSection>
        <Typography variant="h1">{t("page.notfound.title")}</Typography>
        <Typography variant="body1">{t("page.notfound.text")}</Typography>
    </ContentSection>
    </>
}

export default NotFound;